import React from "react";
import { BRAND } from "@/constants/testIds";

/** AuraVeil primary logo (gold wordmark on matte black). */
export default function BrandLogo({ className = "h-12", dataTestid = BRAND.logo }) {
  return (
    <img
      data-testid={dataTestid}
      src="/brand/auraveil-logo.png"
      alt="AuraVeil — discover what lies within"
      className={`${className} w-auto select-none`}
      style={{ mixBlendMode: "screen" }}
      draggable={false}
    />
  );
}
